import { Masthead, Page, eventBus } from '@piggybank/core';
import Logo from 'LogoAlias';
import config from 'configAlias';
import translations from 'contentAlias';
import T from 'prop-types';
import React, { useEffect } from 'react';
import { hot } from 'react-hot-loader/root';
import { connect } from 'react-redux';
import { PageContent } from './PageContent';
import PageTitle from './components/PageTitle';
import { Locale } from './locale';
import { eventActions } from './state/actions';
import { segmentConfigSelectors } from './state/selectors';

export const App = ({
  currentPageName,
  currentSegmentConfig,
  currentSegmentName,
  errorEvent,
  initEvent,
  piggybankEvent,
  productCodes,
}) => {
  useEffect(() => {
    if (!currentSegmentConfig?.formSchema) {
      initEvent();
    }
  }, []);

  useEffect(() => {
    const unsubscribe = eventBus.subscribe(action => {
      if (
        /^onNavigate|onChange|onComponentLoad|onComponentClick$/.test(
          action.type
        )
      ) {
        piggybankEvent({ ...action, translations });
      }
    });

    return () => {
      unsubscribe();
    };
  }, [currentSegmentName, currentPageName]);

  return (
    <Locale culture={config.culture} translations={translations}>
      <PageTitle
        branding={config.branding}
        pageName={currentPageName}
        segmentName={currentSegmentName}
      />
      <Page headerSlot={<Masthead logoSlot={<Logo />} marginBottom={4} />}>
        <PageContent errorEvent={errorEvent} productCodes={productCodes} />
      </Page>
    </Locale>
  );
};

App.propTypes = {
  productCodes: T.object,
  currentSegmentName: T.string.isRequired,
  currentPageName: T.string,
  currentSegmentConfig: T.object.isRequired,
  initEvent: T.func.isRequired,
  piggybankEvent: T.func,
  errorEvent: T.func.isRequired,
};

export default connect(
  state => ({
    currentSegmentConfig: segmentConfigSelectors.getCurrentSegmentConfig(state),
    currentSegmentName: segmentConfigSelectors.getCurrentSegmentName(state),
    currentPageName: segmentConfigSelectors.getCurrentPageName(state),
    productCodes: state.productCodes,
  }),
  dispatch => ({
    initEvent() {
      return dispatch(eventActions.initEvent());
    },
    piggybankEvent(currentSegmentName, currentPageName, action) {
      return dispatch(
        eventActions.piggybankEvent(currentSegmentName, currentPageName, action)
      );
    },
    errorEvent(data) {
      return dispatch(eventActions.errorEvent(data));
    },
  }),
  (stateProps, dispatchProps, ownProps = {}) => ({
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
    piggybankEvent(action) {
      return dispatchProps.piggybankEvent(
        stateProps.currentSegmentName,
        stateProps.currentPageName,
        action
      );
    },
  })
)(hot(App));
